"use strict";
// (C) 2022-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranularPermissionsDropdownWithBubble = exports.GranularPermissionsDropdown = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var utils_1 = require("../utils");
var locales_1 = require("../../../../locales");
var GranularPermissionsDropdownBody_1 = require("./GranularPermissionsDropdownBody");
var Bubble_1 = require("../../../../Bubble");
exports.GranularPermissionsDropdown = function (_a) {
    var grantee = _a.grantee, granteePossibilities = _a.granteePossibilities, isDropdownDisabled = _a.isDropdownDisabled, isDropdownOpen = _a.isDropdownOpen, toggleDropdown = _a.toggleDropdown, onChange = _a.onChange, onDelete = _a.onDelete, className = _a.className, mode = _a.mode;
    var intl = react_intl_1.useIntl();
    var _b = tslib_1.__read(react_1.useState(granteePossibilities.assign.effective), 2), selectedPermission = _b[0], setSelectedPermission = _b[1];
    var handleSetSelectedPermission = function (permission) {
        setSelectedPermission(permission);
    };
    var handleClick = react_1.useCallback(function () {
        if (!isDropdownDisabled) {
            toggleDropdown();
        }
    }, [isDropdownDisabled, toggleDropdown]);
    var granularGranteeClassName = utils_1.getGranularGranteeClassNameId(grantee);
    var buttonValue = intl.formatMessage(locales_1.granularPermissionMessageLabels[selectedPermission]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: classnames_1.default("s-granular-permission-button", "gd-granular-permission-button", "dropdown-button", granularGranteeClassName, {
                "is-active": isDropdownOpen,
                "gd-icon-navigateup": !isDropdownDisabled && isDropdownOpen,
                "gd-icon-navigatedown": !isDropdownDisabled && !isDropdownOpen,
                disabled: isDropdownDisabled,
                "gd-icon-right": !isDropdownDisabled,
            }), onClick: handleClick },
            react_1.default.createElement("div", { className: "s-granular-permission-button-title gd-granular-permission-button-title" }, buttonValue)),
        react_1.default.createElement(GranularPermissionsDropdownBody_1.GranularPermissionsDropdownBody, { alignTo: granularGranteeClassName, grantee: grantee, granteePossibilities: granteePossibilities, toggleDropdown: toggleDropdown, isShowDropdown: isDropdownOpen, onChange: onChange, onDelete: onDelete, selectedPermission: selectedPermission, handleSetSelectedPermission: handleSetSelectedPermission, mode: mode })));
};
exports.GranularPermissionsDropdownWithBubble = Bubble_1.withBubble(exports.GranularPermissionsDropdown);
//# sourceMappingURL=GranularPermissionsDropdown.js.map